import { store } from "@betacrew/jars-flux";
import { all, put, takeLatest } from "redux-saga/effects";
import { addNotifications } from "../../../../toaster/ToasterPortalSlice";
import { TOASTER_VARIANT } from "../../../../../components/toast/constants";
import { setFormSettings, setImportData, setIsImportDataGridViewLoaded, setIsQbInactiveVendor, setIsWebConnectorAuthenticated, setLoadingState, setWebConnectorSyncData } from "./WebConnectorSlice";
import { componentKey } from "./WebConnectorSlice";
import IntegrationDataService from "../../../../../../services/IntegrationDataService";
import FormsDataService from "../../../../../../services/FormsDataService";
import General from "../../../../../../libs/utility/General";
import { QBD_LOADING_STATES } from "../../constants";
import { GENERIC_ERROR_MESSAGE } from "../../../../constants/constants";

export const { qbWebConnectorUserLogin, getLoadImportData, getFormSetting, getWebConnectorSyncData, qbWebConnectorDownload, updateInactiveVendor, getIsInactiveVendors} = {

    qbWebConnectorUserLogin: (payload) => {
        return {
            type: "QBD_WBCONNECTOR/USER_LOGIN",
            payload: payload
        }
    },
    getLoadImportData: (payload) => {
        return {
            type: "QBD_WBCONNECTOR/GET_LOAD_IMPORT_DATA",
            payload: payload
        }
    },
    getFormSetting: (payload) => {
        return {
            type: "QBD_WBCONNECTOR/GET_FORM_SETTING",
            payload: payload
        }
    },
    getWebConnectorSyncData: (payload) => {
        return {
            type: "QBD_WBCONNECTOR/GET_WBCONNECTOR_SYNCDATA",
            payload: payload
        }
    },
    qbWebConnectorDownload: (payload) => {
        return {
            type: "QBD_WBCONNECTOR/GET_WBCONNECTOR_DOWNLOAD",
            payload: payload
        }
    },
    updateInactiveVendor: (payload) => {
        return {
            type: "QBD_WBCONNECTOR/UPDATE_INACTIVE_VENDOR",
            payload: payload
        }
    },
    getIsInactiveVendors: (payload) => {
        return {
            type: "QBD_WBCONNECTOR/GET_INACTIVE_VENDOR",
            payload: payload
        }
    },
}

function* qbWebConnectorUserLoginAsync(action) {
    try {
        yield put(setLoadingState({ state: QBD_LOADING_STATES.PAGE_LOADING }));
        const response = yield IntegrationDataService.qbWebConnectorUserLogin(action.payload);
        if (response?.data) {
            if (response?.data?.Status === 1) {
                if (response?.data?.Data === true) {
                    yield put(setIsWebConnectorAuthenticated(true));
                }
                else {
                    yield put(addNotifications({ heading: "Error", message: response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
                }

            } else {
                yield put(addNotifications({ heading: "Error", message: response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
            }
        }
    } catch (error) {
        yield put(addNotifications({ heading: "Error", message: GENERIC_ERROR_MESSAGE, variant: TOASTER_VARIANT.DANGER }));
    }
    finally {
        yield put(setLoadingState({ state: QBD_LOADING_STATES.PAGE_DATA_READY }));
    }
}
function* getLoadImportDataAsync(action) {
    try {
        yield put(setLoadingState({ state: QBD_LOADING_STATES.PAGE_LOADING }));
        const { integrationImportRequestDto } = action.payload;
        const response = yield IntegrationDataService.getIntegrationImportData(integrationImportRequestDto);
        if (response?.data?.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            yield put(setImportData(response?.data?.Data));
            yield put(setIsImportDataGridViewLoaded(true));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch Import Data", message: GENERIC_ERROR_MESSAGE }));
    }
    finally {
        yield put(setLoadingState({ state: QBD_LOADING_STATES.PAGE_DATA_READY }));
    }
}
function* getFormSettingAsync(action) {
    try {
        const { formId, year } = action.payload;
        const response = yield FormsDataService.getFormSetting(formId, year);
        if (response?.data) {
            if (response?.data?.Status === 1) {
                yield put(setFormSettings(response?.data?.Data));
            } else {
                yield put(addNotifications({ heading: "Error", message: response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: GENERIC_ERROR_MESSAGE, variant: TOASTER_VARIANT.DANGER }));
    }
}
function* getWebConnectorSyncDataAsync() {
    try {
        yield put(setLoadingState({ state: QBD_LOADING_STATES.PAGE_LOADING }));
        const response = yield IntegrationDataService.handleWebConnectorSyncConfirmationEmail();
        if (response?.data) {
            if (response?.data?.Status === 1) {
                yield put(setWebConnectorSyncData(response?.data?.Data));
            } else {
                yield put(addNotifications({ heading: "Error", message: response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
            }
        }
        else {
            yield put(addNotifications({ heading: "Error", message: response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: GENERIC_ERROR_MESSAGE, variant: TOASTER_VARIANT.DANGER }));
    }
    finally {
        yield put(setLoadingState({ state: QBD_LOADING_STATES.PAGE_DATA_READY }));
    }
}

function* qbWebConnectorDownloadAsync() {
    try {
        yield put(setLoadingState({ state: QBD_LOADING_STATES.PAGE_LOADING }));
        const response = yield IntegrationDataService.qBWebConnectorDownload();
        if (response?.data?.Status === 1) {
            const { Base64, Name } = response?.data?.Data;
            General.downloadFile(Base64, Name);
        } else {
            yield put(addNotifications({ heading: "Error", message: response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: GENERIC_ERROR_MESSAGE, variant: TOASTER_VARIANT.DANGER }));
    }
    finally {
        yield put(setLoadingState({ state: QBD_LOADING_STATES.PAGE_DATA_READY }));
    }
}

function* updateInactiveVendorAsync(action) {
    try {
        yield put(setLoadingState({ state: QBD_LOADING_STATES.PAGE_LOADING }));
        const { model } = action.payload;
        const response = yield IntegrationDataService.updateQbInactiveVendor(model);
        if (response?.data?.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            if(response?.data?.Data){
                yield put(setIsQbInactiveVendor(response?.data?.Data));
            }
            else{
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            }
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch Import Data", message: GENERIC_ERROR_MESSAGE }));
    }
    finally {
        yield put(setLoadingState({ state: QBD_LOADING_STATES.PAGE_DATA_READY }));
    }
}

function* getIsInactiveVendorsAsync() {
    try {
        yield put(setLoadingState({ state: QBD_LOADING_STATES.PAGE_LOADING }));
        const response = yield IntegrationDataService.getIsInactiveVendors();
        if (response?.data?.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            if(response?.data?.Data){
                yield put(setIsQbInactiveVendor(response?.data?.Data));
            }
            else{
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            }
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch Import Data", message: GENERIC_ERROR_MESSAGE }));
    }
    finally {
        yield put(setLoadingState({ state: QBD_LOADING_STATES.PAGE_DATA_READY }));
    }
}



function* rootSaga() {
    yield all([
        takeLatest(qbWebConnectorUserLogin().type, qbWebConnectorUserLoginAsync),
        takeLatest(getLoadImportData().type, getLoadImportDataAsync),
        takeLatest(getFormSetting().type, getFormSettingAsync),
        takeLatest(getWebConnectorSyncData().type, getWebConnectorSyncDataAsync),
        takeLatest(qbWebConnectorDownload().type, qbWebConnectorDownloadAsync),
        takeLatest(updateInactiveVendor().type, updateInactiveVendorAsync),
        takeLatest(getIsInactiveVendors().type, getIsInactiveVendorsAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);